var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
var HandInfoIcon = forwardRef(function (props, svgRef) {
    var _a = props.color, color = _a === void 0 ? 'currentColor' : _a, _b = props.size, size = _b === void 0 ? 24 : _b, rest = __rest(props, ["color", "size"]);
    return (React.createElement("svg", __assign({ width: size, height: size, viewBox: "0 0 15 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, rest),
        React.createElement("path", { d: "M11.15 10.25h1.046a2.25 2.25 0 011.872 1.002l.232.348-6.826 2.655a2.7 2.7 0 01-2.43-.239L1.25 11.6V7.55h.9c1.184 0 2.537.435 3.15 1.35h2.25a2.25 2.25 0 012.25 2.25H4.85", stroke: color, strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M9.353 6.644a2.697 2.697 0 100-5.394 2.697 2.697 0 000 5.394z", stroke: "#DF542F", strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M9.35 3.05v1.8", stroke: "#4E4E91", strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));
});
HandInfoIcon.displayName = 'HandInfoIcon';
export default HandInfoIcon;
